import { PlaceActionType } from './place-action-type';
import { castArray } from 'lodash';

export interface UpdatePlaceErrorAction {
  errors: Error[];
  placeKey: string;
  type: PlaceActionType.UpdatePlaceError;
}

export const updatePlaceError = (
  placeKey: string,
  errors: Error | readonly Error[],
): UpdatePlaceErrorAction => ({
  errors: castArray(errors),
  placeKey,
  type: PlaceActionType.UpdatePlaceError,
});
